





















































































































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faShoppingBag } from '@fortawesome/free-solid-svg-icons/faShoppingBag';
import { faUserCircle } from '@fortawesome/free-regular-svg-icons/faUserCircle';

import bButton from 'bootstrap-vue/es/components/button/button';
import bCollapse from 'bootstrap-vue/es/components/collapse/collapse';
import bDropdown from 'bootstrap-vue/es/components/dropdown/dropdown';
import bDropdownItem from 'bootstrap-vue/es/components/dropdown/dropdown-item';
import bFormInput from 'bootstrap-vue/es/components/form-input/form-input';
import bInputGroup from 'bootstrap-vue/es/components/input-group/input-group';
import bInputGroupAppend from 'bootstrap-vue/es/components/input-group/input-group-addon';
import bNavbar from 'bootstrap-vue/es/components/navbar/navbar';
import bNavbarBrand from 'bootstrap-vue/es/components/navbar/navbar-brand';
import bToggle from 'bootstrap-vue/es/directives/toggle/toggle';

import { WithAppContext } from '@/mixins';

import DEMO_DATA from '@/demo-data';

import Cart from './Cart.vue';
import Logo from './Logo';
import NavLink from './NavLink.vue';
import NavMegaMenu from './NavMegaMenu.vue';
import Sidenav from './Sidenav.vue';

const SmallNavbarProps = Vue.extend({
  props: {
    logo: {
      type: Object as () => Logo,
      required: true,
    },
  },
});

@Component({
  components: {
    Cart,
    FontAwesomeIcon,
    NavLink,
    NavMegaMenu,
    Sidenav,

    bButton,
    bCollapse,
    bDropdown,
    bDropdownItem,
    bFormInput,
    bInputGroup,
    bInputGroupAppend,
    bNavbar,
    bNavbarBrand,
  },
  directives: {
    bToggle,
  },
})
export default class SmallNavbar extends mixins(SmallNavbarProps, WithAppContext) {
  public readonly faBars = faBars;
  public readonly faSearch = faSearch;
  public readonly faShoppingBag = faShoppingBag;
  public readonly faUserCircle = faUserCircle;
  public readonly collections = DEMO_DATA.menu;
  public readonly cartProducts = DEMO_DATA.cart;

  get smNavBarClassObj() {
    return {
      ['sm-navbar']: true,
      ['d-md-none']: true,
      ['show-fixed-top-nav']: !this.hideFixedNavbar,
    };
  }
}

